import { FinanciamentoPromotoraDTO } from '../shared/dto/financiamentoPromotoraDTO';
import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/financiamentoPromotoraController');

export default class FinanciamentoPromotoraService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarFinanciamentoPromotora(idFinanciamento: string) {
    return await this.axios.get(`/listarFinanciamentoPromotora?idFinanciamento=${idFinanciamento}`);
  };

  async incluirAlterarFinanciamentoPromotora(idFinanciamento: string, dto: FinanciamentoPromotoraDTO[]) {
    return await this.axios.post(`incluirAlterarFinanciamentoPromotora?financiamentoId=${idFinanciamento}`, dto);
  };

}